import React from 'react';
import type { FC } from 'react';
import { match } from 'variant';
import { Box, Text, Alert, Spinner, useAsyncCallback } from '@wix/cli-ui-kit';
import { useARMClient } from '@wix/arm-client';
import type { SemVer } from 'semver';
import { useProjectModel } from '../../model.js';
import { CreatePreview } from './Steps/CreatePreview.js';

interface ReleaseProps {
  baseUrl?: string;
  isPublished: boolean;
  latestVersion: SemVer;
  label?: string;
}

export const Release: FC<ReleaseProps> = ({ baseUrl, label }) => {
  const {
    model: {
      config: { appId },
    },
  } = useProjectModel();

  const { release } = useARMClient();

  const releaseAction = useAsyncCallback(async (_, tag: string) => {
    const baseUrl = await release(appId, tag);

    return {
      baseUrl,
    };
  });

  function onPreviewCreated({ tag }: { tag: string }) {
    return releaseAction.execute(tag);
  }

  return (
    <>
      <CreatePreview
        baseUrl={baseUrl}
        label={label}
        onCreated={({ armTag }) => onPreviewCreated({ tag: armTag })}
      />
      {match(releaseAction.status, {
        NotRequested: () => null,
        Error: () => null,
        Loading: () => <Spinner text={<Text>Releasing...</Text>} />,
        Success: ({ result: { baseUrl } }) => (
          <Box flexDirection="column" gap={1}>
            <Alert type="success">
              <Text bold>Site published on {baseUrl}</Text>
            </Alert>
          </Box>
        ),
      })}
    </>
  );
};
